export const METS_PREFIX_REGISTER_PAGE_TITLE = 'es:mapfre:oim:registro area de clientes';

export enum RegisterAnalyticsPageTitles {
  INITIAL_DATA = ':documento identidad',
  RGPDUE = ':aceptacion proteccion de datos',
  VALIDATE_EMAIL = ':correo',
  VALIDATE_PHONE = ':telefono',
  VALIDATE_IBAN = ':iban',
  VALIDATE_IBAN_ATTEMPT = 'registro:verificar identidad:step error-dato incorrecto',
  SECURITY_PHONE_CODE = ':codigo verificacion teléfono',
  SECURITY_EMAIL_CODE = ':codigo verificacion email',
  CONTACT_DATA = ':registro:paso4-validar datos contacto',
  CONTACT_DATA_CAMPAIGN = 'registro:paso4-validar datos contacto campañas',
  CREATE_PASSWORD = ':crear contraseña',
  REGISTER_SUCCESS = ':proceso completado',
  REGISTER_SUCCESS_TECUIDAMOS = ':proceso completado tecuidamos-aci',
  CHANGE_USER_STATUS = 'registro:paso8-exito registro y error base datos',
  REGISTER_SUCCESS_TECUIDAMOS_ERROR = ':proceso completado aci y error tecuidamos',
  TE_CUIDAMOS = ':unete te cuidamos',
  TE_CUIDAMOS_CONTACT = ':datos personales tecuidamos-aci',
  NO_PROFILE = ':registro:step error-cliente no perfil',
  SERVER_ERROR = ':registro:step error-sistema',
  INCOMING_CALL_ERROR = ':registro:step error-llamada',
  REGISTER_ERROR = ':registro:step error-operacion no realizada',
  ALREADY_REGISTER = ':usuario registrado',
  CUSTOMER_CANCELLED = 'registro:step error-cliente cancelado',
  NOT_FOUND = ':no encontrado base de datos',
  CLIENT_DUPLICATE = ':nombre y apellidos',
  NON_TAKER_POLICY = ':no tomador poliza'
}